import { useState, useEffect, useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import Header from '../components/landing/Header'
import HeroSection from '../components/landing/HeroSection'
import FeaturesSection from '../components/landing/FeaturesSection'
import HowItWorks from '../components/landing/HowItWorks'
import PricingSection from '../components/landing/PricingSection'
import FirstMonthFree from '../components/landing/FirstMonthFree'
import TrustBenefits from '../components/landing/TrustBenefits'
import FinalCTA from '../components/landing/FinalCTA'
import Footer from '../components/landing/Footer'
import RequestAccessModal from '../components/landing/RequestAccessModal'
import '../components/landing/LandingStyles.css'

export default function LandingPage() {
  const [showModal, setShowModal] = useState(false)
  const navigate = useNavigate()

  const handleRequestAccess = useCallback(() => setShowModal(true), [])
  const handleLogin = useCallback(() => navigate('/login'), [navigate])

  // Scroll reveal observer
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('mf-visible')
          }
        })
      },
      { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
    )

    const elements = document.querySelectorAll('.mf-reveal')
    elements.forEach(el => observer.observe(el))

    return () => observer.disconnect()
  }, [])

  // Close modal on Escape
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setShowModal(false)
    }
    if (showModal) {
      window.addEventListener('keydown', onKey)
      return () => window.removeEventListener('keydown', onKey)
    }
  }, [showModal])

  return (
    <div className="mf-landing">
      <Header />
      <main>
        <HeroSection onRequestAccess={handleRequestAccess} onLogin={handleLogin} />
        <FeaturesSection />
        <HowItWorks />
        <PricingSection />
        <FirstMonthFree />
        <TrustBenefits />
        <FinalCTA onRequestAccess={handleRequestAccess} onLogin={handleLogin} />
      </main>
      <Footer />

      {showModal && (
        <RequestAccessModal onClose={() => setShowModal(false)} />
      )}
    </div>
  )
}
